import * as colors from "../../constants/colors";
import * as languages from "../../constants/languages";
import browserHistory from "react-router/lib/browserHistory";
import { english, spanish } from "../../constants/strings";
import { login } from "../../api/auth";
import { css, StyleSheet } from "aphrodite";
import loginStyles from "../../styles/loginStyles";
import Link from "react-router/lib/Link";
import LoggedOutPage from "../LoggedOutPage";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { reportWarning, reportInfo } from "../../bugReporting";

const styles = StyleSheet.create({
	noAccount: {
		marginTop: 24,
		textAlign: "center",
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		lineHeight: 1.33,
		fontSize: 15,
		color: colors.black4,
	},
	link: {
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		lineHeight: 1.33,
		fontSize: 15,
		color: colors.black4,
		fontWeight: 300,
	},
});

export default class LoginPage extends PureComponent {
	static propTypes = {
		params: PropTypes.object,
		route: PropTypes.object,
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		redirectPath: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = { error: null, email: "" };
	}

	_login = e => {
		e.preventDefault();
		login(this.state.email)
			.then(() => {
				reportInfo("login successfull, rerouting");
			})
			.then(() => {
				const url = this._redirectPath();
				browserHistory.push(url);
				window.location.reload();
			})
			.catch(err => {
				reportWarning(err);
				if (err.response && err.response.status === 400) {
					this.setState({
						error: this.strings.errors.accountNotFound,
					});
				} else {
					this.setState({
						error: this.strings.errors.loginFailed,
					});
				}
			});
	};

	_currentPath = () => {
		return this.props.redirectPath
			? `${this.props.pathname}?redirectpath=${encodeURIComponent(this.props.redirectPath)}`
			: this.props.pathname;
	};

	_redirectPath = () => {
		if (this.props.redirectPath) {
			return `${this.props.redirectPath}${
				this.props.language && this.props.redirectPath.indexOf("language") === -1
					? `${this.props.redirectPath.indexOf("?") > -1 ? "&" : "?"}language=${
							this.props.language
						}`
					: ""
			}`;
		} else {
			return `/?language=${this.props.language}`;
		}
	};

	_setEmail = email => {
		this.setState({
			error: null,
			email,
		});
	};

	render() {
		return (
			<LoggedOutPage
				pageTitle={this.strings.LOGIN}
				language={this.props.language}
				currentRoute={this._currentPath()}
			>
				<div>
					<form className={css(loginStyles.form)}>
						<div className={css(loginStyles.formItem)}>
							<label htmlFor="email" className={css(loginStyles.label)}>
								{this.strings.EmailAddress}
							</label>
							<input
								className={css([
									loginStyles.input,
									this.state.error ? loginStyles.inputError : "",
								])}
								id="email"
								type="text"
								value={this.state.email}
								onChange={e => this._setEmail(e.target.value)}
							/>
						</div>
						<div className={css(loginStyles.errorMessage)}>{this.state.error}</div>
						<div className={css(loginStyles.buttonContainer)}>
							<button className={css(loginStyles.button)} onClick={this._login}>
								{this.strings.LOG_IN}
							</button>
						</div>
					</form>
					<div className={css(styles.noAccount)}>
						{this.strings.dontHaveAnAccount}{" "}
						<Link
							className={css(styles.link)}
							to={{ pathname: "signup", query: { language: this.props.language } }}
						>
							{this.strings.signUp}
						</Link>
					</div>
				</div>
			</LoggedOutPage>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js